export function getIconAltTag(value: string | number) {
  return `Picture of a dog who is ${String(value)}`;
}
